// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1H25_","signatureButtonsRight":"ModalSign_signatureButtonsRight__23sZB"};